<template>
  <a v-if="linkedViewPath" :href="linkedViewPath" :class="disabled ? 'disabled-link' : 'btn-link'">
    <slot></slot>
  </a>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
  import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
  import {ViewLinkType} from "~/models/listViews/viewLinkType"
  import contentElementBaseMixin from "~/mixins/listViews/contentElementBaseMixin"
  import {RouteHelper} from '~/helpers/routeHelper'
  import {Route} from '~/enums/route'
  import BaseObjectModelEntry from "~/models/objectModelEntries/baseObjectModelEntry";
  import breadcrumbMixin from "../mixins/breadcrumbMixin";
  import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";

  export default Vue.extend({
    components: {},
    mixins: [
      contentElementBaseMixin,
      breadcrumbMixin,
    ],
    props: {
      entry: {
        type: Object as () => BaseObjectModelEntry,
        required: true,
      },
      disabled:{
        type: Boolean,
        default: false,
      }
    },
    computed: {
      linkedViewPath(): string {
        if (!this.contentElement.linkedViewData) return null;
        if (this.contentElement.linkedViewData.type === ViewLinkType.none) return null;

        let linked_entry: ObjectModelEntry;
        if (this.contentElement.linkedViewData.type === ViewLinkType.detailView) {
          let contentElementProperty = null
          if (this.contentElement?.property) {
            contentElementProperty = ObjectModelProperty.repo.findById(this.contentElement.property.client_id, this.contentElement.property.id)
          }
          if (contentElementProperty?.property_type === ObjectModelPropertyRootType.MappedProperty) {
            linked_entry = this.entry.all_related_entries?.find(entry =>
              (entry.object_model_id === this.contentElement.linked_view_object_model_id) ||
              (entry.object_model_id.$oid === this.contentElement.linked_view_object_model_id));
            if (!linked_entry && this.entry.object_model_id === this.contentElement.linked_view_object_model_id) {
              linked_entry = this.entry
            }
          } else {
            linked_entry = this.entry;
          }
          if (!linked_entry) return;
        }

        let query: object;
        if (this.currentBreadcrumbs) {
          let linkedBreadcrumb: object;
          if (this.contentElement.linkedViewData.type === ViewLinkType.listView) {
            linkedBreadcrumb = {t: 'lv', v: this.contentElement.linkedViewData.id};
          } else {
            linkedBreadcrumb = {t: 'dv', v: {dv: this.contentElement.linkedViewData.id, e: linked_entry.id}};
          }
          query = {bc: [...this.currentBreadcrumbs, linkedBreadcrumb]};
        } else if (this.selectedPublishedListView) {
          // @ts-ignore
          if (window.DNR) {
            query = {from: 'My Dashboard', from_list_view: this.selectedPublishedListView.list_view_id};
            // @ts-ignore
            query["from"] = window.IS_ENTITY ? "Entity's Dashboard" : "My Dashboard";
          } else {
          query = {from: 'Reporting & Submissions Dashboard', from_list_view: this.selectedPublishedListView.list_view_id};
          }
        } else {
          query = {from: 'Reporting & Submissions Dashboard'};
        }

        let routeEnum;
        switch (this.contentElement.linkedViewData.type) {
          case ViewLinkType.detailView:
            routeEnum = this.isPreview ? Route.previewDetailView : Route.detailView;
            return RouteHelper.path({
              route: routeEnum,
              namedWildcardOptions: [
                {wildcard: ':id', modelOrId: this.contentElement.linkedViewData.id},
                {wildcard: ':entry_id', modelOrId: linked_entry},
              ],
              query,
            });
          case ViewLinkType.listView:
            routeEnum = this.isPreview ? Route.previewListView : Route.listView;
            return RouteHelper.path({
              route: routeEnum,
              modelOrId: this.contentElement.linkedViewData.id,
              query,
            });
        }
      },
    },
  });
</script>